import { newObjectIdHex } from './objectIdHex'

const OBJECT_ID_HEX = /^[a-f0-9]{24}$/i

export function isObjectIdHex(value: string): boolean {
  return OBJECT_ID_HEX.test(value.trim())
}

/** Preserves stable draft option ids by parallel index; assigns new ids for new rows. */
export function optionIdsForLabels(
  labels: readonly string[],
  existingIds: readonly string[] | undefined,
): string[] {
  return labels.map((_, index) => {
    const candidate = existingIds?.[index]?.trim() ?? ''
    return isObjectIdHex(candidate) ? candidate : newObjectIdHex()
  })
}

export function withoutIndexAt<T>(arr: readonly T[], index: number): T[] {
  return arr.filter((_, j) => j !== index)
}
